"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 23 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var ProductInfoFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductInfoFilterConverter, _DataObjectConverter_);

  function ProductInfoFilterConverter() {
    _classCallCheck(this, ProductInfoFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductInfoFilterConverter).apply(this, arguments));
  }

  return ProductInfoFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductInfoFilterConverter = ProductInfoFilterConverter;